import { webLinkUrl } from "./link-display";

export type WorkspaceLink =
  | { kind: "feed"; label: string; channelId: string | null }
  | { kind: "post"; label: string; channelId: string }
  | { kind: "channel"; label: string; channelId: string }
  | { kind: "record"; label: string; channelId: string; recordId: string }
  | { kind: "view"; label: string; channelId: string; view: string; dataSetId: string | null }
  | { kind: "dataSet"; label: string; channelId: string; dataSetId: string };

/** Classify only this workspace's canonical channel and feed destinations. */
export function workspaceLink(href: string, origin: string): WorkspaceLink | null {
  // Relative links can render on the server; absolute links wait for the real origin.
  if (!origin && (!href.startsWith("/") || href.startsWith("//"))) return null;
  const base = origin || "https://workspace.invalid";
  const url = webLinkUrl(href, base);
  if (!url || url.origin !== base || url.username || url.password) return null;
  if (url.pathname === "/workspace/feed") return { kind: "feed", label: "Workspace feed", channelId: null };
  const encoded = /^\/workspace\/channels\/([^/]+)\/?$/.exec(url.pathname)?.[1];
  if (!encoded) return null;
  let channelId: string;
  try {
    channelId = decodeURIComponent(encoded);
  } catch {
    return null;
  }
  const params = url.searchParams;
  const recordId = params.get("record")?.trim();
  if (recordId) return { kind: "record", label: "Record", channelId, recordId };
  const view = params.get("view")?.trim() ?? "";
  if (view === "feed") {
    return params.get("thread")?.startsWith("post:")
      ? { kind: "post", label: "Channel post", channelId }
      : { kind: "feed", label: "Channel feed", channelId };
  }
  const dataSetId = params.get("dataSet")?.trim() || null;
  if (view.startsWith("saved:") && view.length > 6) return { kind: "view", label: "View", channelId, view: view.slice(6), dataSetId };
  if (dataSetId) return { kind: "dataSet", label: "Data set", channelId, dataSetId };
  return { kind: "channel", label: "Channel", channelId };
}
